import React, { FC, useMemo, memo } from 'react';
import { useFormikContext } from 'formik';
import _isEmpty from 'lodash/isEmpty';
import FormikUncontrolledRadioGroup from '@minecraft.formik-uncontrolled-radio-group';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { getDependentFilterKey } from '../../../shared/utils';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';

type Props = {
  subLabel: string;
} & FilterData;

const SkillLevels: FC<Props> = ({ name, label, subLabel }) => {
  const { values } = useFormikContext();

  const { getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.skills);

  const dependentFilterKey = useMemo(() => getDependentFilterKey(name), []);

  const options = useMemo(() => getMatchedSearchOptions(name), [getMatchedSearchOptions, name]);

  return (
    <>
      <Label $asHint $subLabel={subLabel}>
        {label}
      </Label>
      <FormikUncontrolledRadioGroup
        hideCount={_isEmpty(values?.skills)}
        saveAsOption
        enableReinitializeDefaultValue
        defaultValue={values[name]}
        disabled={_isEmpty(values[dependentFilterKey])}
        name={name}
        options={options}
      />
    </>
  );
};

export default memo(SkillLevels);
